export const easyForYouData = {
  eyebrow: 'Designed For All',
  title: 'Easy for you, easy for your guests.',
  content: 'We designed our features to be easy for everyone — before, during, and even after RSVP.',
} as const;
